import React, { Component } from "react";
import { Loader } from "ui-kit-ck-consultant";

import WidgetWrapper from "./WidgetWrapper";
import CA from "../CA";

export default class WidgetCA extends Component {
  render() {
    const data = this.props.detailData;

    return (
      <WidgetWrapper
        title="Chiffre d'affaires"
        noCard
        isCustomizing={this.props.isCustomizing}
        dragHandleProps={this.props.dragHandleProps}
        onHide={this.props.onHide}
      >
        {!data ? (
          <Loader />
        ) : data.CA ? (
          <CA data={data} perimeter={this.props.perimeter} />
        ) : (
          <p className="mt-10 mb-10" style={{ textAlign: "center", color: "#999" }}>
            Aucune donnée disponible
          </p>
        )}
      </WidgetWrapper>
    );
  }
}
